document.addEventListener("DOMContentLoaded", function () {

  // Safe money formatter (Shopify.formatMoney ki jagah)
  function formatMoney(amount) {
    amount = amount / 100;
    return "$" + amount.toFixed(2);
  }

  const radios = document.querySelectorAll("variant-radios input[type='radio']");
  const jsonNode = document.querySelector("variant-radios script[type='application/json']");

  if (!radios.length || !jsonNode) return;

  const variants = JSON.parse(jsonNode.textContent);

  // Main update function
  function updatePrices(variant) {

    const regular = document.querySelector("[data-regular-price]");
    const sale = document.querySelector("[data-sale-price]");
    const compare = document.querySelector("[data-compare-price]");
    const atcPrice = document.querySelector("[data-atc-price]");

    // Main Price
    if (regular) regular.innerHTML = formatMoney(variant.price);
    if (sale) sale.innerHTML = formatMoney(variant.price);

    // Compare Price
    if (compare) {
      if (variant.compare_at_price > variant.price) {
        compare.style.display = "inline-block";
        compare.innerHTML = formatMoney(variant.compare_at_price);
      } else {
        compare.style.display = "none";
      }
    }

    // ⭐ ADD TO CART BUTTON PRICE UPDATE ⭐
    if (atcPrice) atcPrice.innerHTML = formatMoney(variant.price);
  }

  // Variant Change Listener
  radios.forEach(radio => {
    radio.addEventListener("change", function () {
      const value = this.value;
      const variant = variants.find(v => v.option1 === value);
      if (variant) updatePrices(variant);
    });
  });

});
